// src/apiService.js
import axios from 'axios'; // Make sure this line is present

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };

  export const fetchRoleData = async (clientId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/roles/getroleslist/${clientId}`,
        {
          headers: {
            'auth_key': `${getAuthKey()}`,
          }
        }
      );
      return response.data; // Return the list of countries
    } catch (error) {
      console.error('Error fetching countries:', error);
      alert('Error fetching countries:'+ error);
      throw error;
    }
  };

  export const fetchUserDataByRole = async (clientId,roleId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/users/getusersbyrole/${clientId}/${roleId}`,
        {
          headers: {
            'auth_key': `${getAuthKey()}`,
          }
        }
      );
      return response.data; // Return the list of countries
    } catch (error) {
      console.error('Error fetching countries:', error);
      alert('Error fetching countries:'+ error);
      throw error;
    }
  };

  export const fetchUserDataUnderLoginUserByClient = async (clientId, userId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/users/getUsersUnderLoginUserByClient/${clientId}/${userId}`,
        {headers: {
            'auth_key': `${getAuthKey()}`,
          }}
      );
      return response.data; // Return the list of countries
    } catch (error) {
      console.error('Error fetching Users:', error);
      alert('Error fetching Users:'+ error);
      throw error;
    }
  };

export const getAttendanceListByFilters = async (req) => {
    try {
        const response = await fetch(`${API_BASE_URL}/client/attendance/getusersattndance`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'auth_key': `${getAuthKey()}`,
              },
              body: JSON.stringify(req),
            });
            if (!response.ok) {
                alert('Network response was not ok');
                throw new Error('Network response was not ok');
            }
    
            const data = await response.json();
            if (data.statusCode === 1002) {
                return { error: data.result };
            } else if (data.statusCode === 1001) {
                return { success: data.result };
            } else {
                return { error: 'Fail' };
            }
        } catch (error) {
          console.error('Error fetching :', error);
          alert('Error fetching :'+ error);
          throw error;
        }
      };



      
export const getallocatedreportByFilters = async (req) => {
  try {
      const response = await fetch(`${API_BASE_URL}/client/office/getallocatedreport`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'auth_key': `${getAuthKey()}`,
            },
            body: JSON.stringify(req),
          });
          if (!response.ok) {
              alert('Network response was not ok');
              throw new Error('Network response was not ok');
          }
  
          const data = await response.json();
          if (data.statusCode === 1002) {
              return { error: data.result };
          } else if (data.statusCode === 1001) {
              return { success: data.result };
          } else {
              return { error: 'Fail' };
          }
      } catch (error) {
        console.error('Error fetching :', error);
        alert('Error fetching :'+ error);
        throw error;
      }
    };


    export const getComponetsListByFilters = async (req) => {
      try {
          const response = await fetch(`${API_BASE_URL}/client/office/getuserfilescomponentsstatus`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'auth_key': `${getAuthKey()}`,
                },
                body: JSON.stringify(req),
              });
              if (!response.ok) {
                  alert('Network response was not ok');
                  throw new Error('Network response was not ok');
              }
      
              const data = await response.json();
              if (data.statusCode === 1002) {
                  return { error: data.result };
              } else if (data.statusCode === 1001) {
                  return { success: data.result };
              } else {
                  return { error: 'Fail' };
              }
          } catch (error) {
            console.error('Error fetching :', error);
            alert('Error fetching :'+ error);
            throw error;
          }
        };